export const CSS_CLASSES = {
  TABLE_CONTAINER: "table-container",
  TABLE_HEAVY_CONTAINER: "table-heavy-container",

  TABLE_ROOT: "table-root",
  TABLE_HEAVY_ROOT: "table-heavy-root",
  TABLE_LIGHT_ROOT: "table-light-root",
  TABLE_MOBILE_ROOT: "table-mobile-root",
  TABLE_MOBILE_COL_ROOT: "table-mobile-col-root",
  TABLE_DESKTOP_ROOT: "table-desktop-root",

  TABLE_HEAD: "table-head",
  TABLE_HEAVY_HEAD: "table-heavy-head",
  TABLE_LIGHT_HEAD: "table-light-head",

  TABLE_HEAD_ROW: "table-head-row",
  TABLE_HEAVY_HEAD_ROW: "table-heavy-head-row",
  TABLE_LIGHT_HEAD_ROW: "table-light-head-row",

  TABLE_BODY: "table-body",
  TABLE_HEAVY_BODY: "table-heavy-body",
  TABLE_LIGHT_BODY: "table-light-body",

  TABLE_BODY_ROW: "table-body-row",
  TABLE_HEAVY_BODY_ROW: "table-heavy-body-row",
  TABLE_LIGHT_BODY_ROW: "table-light-body-row",

  TABLE_BODY_ROW_PRIMARY_ODD: "table-body-row-primary-odd",
  TABLE_BODY_ROW_SECONDARY_ODD: "table-body-row-secondary-odd",
  TABLE_BODY_ROW_ACCENT_ODD: "table-body-row-accent-odd",
  TABLE_BODY_ROW_GRAY_ODD: "table-body-row-gray-odd",
  TABLE_BODY_ROW_ERROR_ODD: "table-body-row-error-odd",
  TABLE_BODY_ROW_WARNING_ODD: "table-body-row-warning-odd",
  TABLE_BODY_ROW_SUCCESS_ODD: "table-body-row-success-odd",

  TABLE_BODY_ROW_PRIMARY_HOVER: "table-body-row-primary-hover",
  TABLE_BODY_ROW_SECONDARY_HOVER: "table-body-row-secondary-hover",
  TABLE_BODY_ROW_ACCENT_HOVER: "table-body-row-accent-hover",
  TABLE_BODY_ROW_GRAY_HOVER: "table-body-row-gray-hover",
  TABLE_BODY_ROW_ERROR_HOVER: "table-body-row-error-hover",
  TABLE_BODY_ROW_WARNING_HOVER: "table-body-row-warning-hover",
  TABLE_BODY_ROW_SUCCESS_HOVER: "table-body-row-success-hover",

  TABLE_BODY_ROW_PRIMARY_HIGHLIGHTED: "table-body-row-primary-highlighted",
  TABLE_BODY_ROW_SECONDARY_HIGHLIGHTED: "table-body-row-secondary-highlighted",
  TABLE_BODY_ROW_ACCENT_HIGHLIGHTED: "table-body-row-accent-highlighted",
  TABLE_BODY_ROW_GRAY_HIGHLIGHTED: "table-body-row-gray-highlighted",
  TABLE_BODY_ROW_ERROR_HIGHLIGHTED: "table-body-row-error-highlighted",
  TABLE_BODY_ROW_WARNING_HIGHLIGHTED: "table-body-row-warning-highlighted",
  TABLE_BODY_ROW_SUCCESS_HIGHLIGHTED: "table-body-row-success-highlighted",

  TABLE_BODY_ROW_FOOTER: "table-body-row-footer",
  TABLE_BODY_ROW_WITH_FOOTER: "table-body-row-with-footer",
  TABLE_BODY_ROW_FOOTER_CONTENT: "table-body-row-footer-content",
  TABLE_BODY_ROW_WITHOUT_BOTTOM_BORDER: "table-body-row-without-bottom-border",

  TABLE_BODY_CELL: "table-body-cell",
  TABLE_HEAVY_BODY_CELL: "table-heavy-body-cell",
  TABLE_LIGHT_BODY_CELL: "table-light-body-cell",
  TABLE_BODY_CELL_ELLIPSIS: "table-body-cell-ellipsis",

  TABLE_HEAD_CELL: "table-head-cell",
  TABLE_HEAVY_HEAD_CELL: "table-heavy-head-cell",
  TABLE_LIGHT_HEAD_CELL: "table-light-head-cell",
  TABLE_HEAD_CELL_SORTABLE: "table-head-cell-sortable",

  TABLE_MOBILE_BODY_ROW_WITHOUT_BOTTOM_BORDER: "table-mobile-body-row-without-bottom-border",
  TABLE_MOBILE_BODY_ROW_FOOTER_CONTENT: "table-mobile-body-row-footer-content",

  TABLE_MOBILE_CARD: "table-mobile-card",
  TABLE_MOBILE_CARD_PRIMARY_ODD: "table-mobile-card-primary-odd",
  TABLE_MOBILE_CARD_SECONDARY_ODD: "table-mobile-card-secondary-odd",
  TABLE_MOBILE_CARD_ACCENT_ODD: "table-mobile-card-accent-odd",
  TABLE_MOBILE_CARD_GRAY_ODD: "table-mobile-card-gray-odd",
  TABLE_MOBILE_CARD_ERROR_ODD: "table-mobile-card-error-odd",
  TABLE_MOBILE_CARD_WARNING_ODD: "table-mobile-card-warning-odd",
  TABLE_MOBILE_CARD_SUCCESS_ODD: "table-mobile-card-success-odd",

  TABLE_MOBILE_CARD_ROW: "table-mobile-card-row",
  TABLE_MOBILE_CARD_ROW_PRIMARY: "table-mobile-card-row-primary",
  TABLE_MOBILE_CARD_ROW_SECONDARY: "table-mobile-card-row-secondary",
  TABLE_MOBILE_CARD_ROW_ACCENT: "table-mobile-card-row-accent",
  TABLE_MOBILE_CARD_ROW_GRAY: "table-mobile-card-row-gray",
  TABLE_MOBILE_CARD_ROW_ERROR: "table-mobile-card-row-error",
  TABLE_MOBILE_CARD_ROW_WARNING: "table-mobile-card-row-warning",
  TABLE_MOBILE_CARD_ROW_SUCCESS: "table-mobile-card-row-success",

  TABLE_MOBILE_CARD_PRIMARY_HIGHLIGHTED: "table-mobile-card-primary-highlighted",
  TABLE_MOBILE_CARD_SECONDARY_HIGHLIGHTED: "table-mobile-card-secondary-highlighted",
  TABLE_MOBILE_CARD_ACCENT_HIGHLIGHTED: "table-mobile-card-accent-highlighted",
  TABLE_MOBILE_CARD_GRAY_HIGHLIGHTED: "table-mobile-card-gray-highlighted",
  TABLE_MOBILE_CARD_ERROR_HIGHLIGHTED: "table-mobile-card-error-highlighted",
  TABLE_MOBILE_CARD_WARNING_HIGHLIGHTED: "table-mobile-card-warning-highlighted",
  TABLE_MOBILE_CARD_SUCCESS_HIGHLIGHTED: "table-mobile-card-success-highlighted",

  TABLE_MOBILE_CARD_ROW_KEY_VALUE_CONTAINER: "table-mobile-card-row-key-value-container",
  TABLE_MOBILE_CARD_ROW_KEY: "table-mobile-card-row-key",
  TABLE_MOBILE_CARD_ROW_VALUE: "table-mobile-card-row-value",

  TABLE_PAGINATION: "table-pagination",
};
